import { queryOptions } from "@tanstack/react-query";
import { ifsApi } from "lib/axios";

// ─── Types ───

export interface ComplianceFuelStop {
  SolutionDate: string | null;
  Cust: string | null;
  Segment: number | null;
  Tractor: string | null;
  TractorOrigin: string | null;
  TractorDestination: string | null;
  Station: string | null;
  compliance: 0 | 1 | null;
  City: string | null;
  State: string | null;
  Latitude: number | null;
  Longitude: number | null;
  store_number: string | null;
  OptimalPPG: number | null;
}

export interface TractorCompliance {
  tractor: string;
  fuelStops: ComplianceFuelStop[];
}

export interface CustomerTractorCompliance {
  averageCompliancePercent: number;
  tractorFuelStops: TractorCompliance[];
}

// ─── Queries ───

async function getCustomerFuelPlanCompliance(
  customerId: string,
  startDate: string,
  endDate: string
): Promise<CustomerTractorCompliance> {
  const response = await ifsApi.get(`companies/${customerId}/fuel-stops/compliance`, {
    params: {
      customerCode: customerId,
      startDate,
      endDate,
    },
  });
  return response.data.data;
}

export const fuelPlanComplianceOptions = (customerId: string, startDate: string, endDate: string) =>
  queryOptions({
    queryKey: ["compliance", customerId, startDate, endDate],
    queryFn: () => getCustomerFuelPlanCompliance(customerId, startDate, endDate),
  });
